import { Button, Form } from 'antd';
import styled from 'styled-components';
import { BlueColors, NeutralColors } from 'theme';

interface ButtonTabProps {
  isSelected?: boolean;
  amountTabs: number;
}

interface ContainerRenderFormProps {
  isShow?: boolean;
}

const ContainerButtons = styled.div`
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid ${NeutralColors[20]};
  margin-top: -8px;
  margin-bottom: 16px;
`;

const ButtonTab = styled.p<ButtonTabProps>`
  cursor: pointer;
  padding: 12px;
  color: ${({ isSelected }) =>
    isSelected ? BlueColors[60] : NeutralColors[100]};
  text-align: center;
  border-bottom: ${({ isSelected }) =>
    isSelected ? `1px solid ${BlueColors[60]}` : undefined};
  width: ${({ amountTabs }) => `${100 / amountTabs}%`};
  margin: 0;
  font-weight: ${({ isSelected }) => (isSelected ? '600' : '400')};

  span {
    margin-left: 6px;
    padding: 2px 6px;
    border-radius: 16px;
    font-size: 12px;
    color: ${NeutralColors[100]};
    font-weight: 600;
    border: 1px solid ${NeutralColors[30]};
  }
`;

const ContainerRenderForm = styled.div<ContainerRenderFormProps>`
  flex: 1;
  display: ${({ isShow }) => (isShow ? 'block' : 'none')};
`;

const ContainerResumeButtons = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const ResumeButton = styled(Button)`
  width: 100%;
`;

const FormDrawer = styled(Form)`
  display: flex;
  flex-direction: column;
  flex: 1;
`;

export {
  ButtonTab,
  ContainerButtons,
  ContainerRenderForm,
  ContainerResumeButtons,
  FormDrawer,
  ResumeButton,
};
